import { getCurrentCognitoUser } from './cognito-user';

export const cognitoSignOut = async () => {
  const cognitoUser = getCurrentCognitoUser();
  if (cognitoUser) await new Promise<void>((r) => cognitoUser.signOut(() => r()));
  console.log('User signed out');
};

export default cognitoSignOut;
